module.exports = __webpack_public_path__ + "static/media/banorte.9ff2b75f.svg";